// Minimalny helper do budowania DOM bez frameworka.

export type Child = Node | string | number | null | undefined | false;
type Handler = (e: Event) => void;
export type Props = { [key: string]: string | number | boolean | null | undefined | Handler };

export function h<K extends keyof HTMLElementTagNameMap>(tag: K, props?: Props | null, ...children: Child[]): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  if (props) {
    for (const [k, v] of Object.entries(props)) {
      if (v === null || v === undefined || v === false) continue;
      if (typeof v === 'function') el.addEventListener(k.replace(/^on/, '').toLowerCase(), v);
      else if (k === 'class') el.className = String(v);
      else if (v === true) el.setAttribute(k, '');
      else el.setAttribute(k, String(v));
    }
  }
  append(el, children);
  return el;
}

export function append(el: Element, children: Child[]): void {
  for (const c of children) {
    if (c === null || c === undefined || c === false) continue;
    el.append(typeof c === 'object' ? c : String(c));
  }
}

export function clear(el: Element): void {
  el.replaceChildren();
}

/** Przycisk; `label` to tekst, element albo lista (np. ikona + napis). */
export function button(label: Child | Child[], onClick: () => void, opts: { class?: string; testid?: string; disabled?: boolean; title?: string } = {}): HTMLButtonElement {
  return h('button', { type: 'button', class: opts.class ?? 'btn', 'data-testid': opts.testid, disabled: opts.disabled, title: opts.title, onclick: onClick }, ...(Array.isArray(label) ? label : [label]));
}

/** Lekki "bump" animacji (np. drżenie przy błędzie). */
export function shake(el: Element): void {
  el.classList.remove('shake');
  void (el as HTMLElement).offsetWidth;
  el.classList.add('shake');
}

export function stars(n: number, total = 3): string {
  return '⭐'.repeat(n) + '☆'.repeat(Math.max(0, total - n));
}

/** Mierzy miejsce tłumaczenia (`pl`, widoczne albo nie — zajmuje miejsce zawsze) i zapisuje je w `--pl-h` pudełka (dymek, wiersz odpowiedzi, przykład): CSS wyśrodkowuje po nim zdanie, gdy tłumaczenie jest schowane
 *  (SPEC §23.35.3). Tłumaczenie bywa kilkuwierszowe (telefon), więc samej wysokości jednej linijki nie wystarcza. Bez `ResizeObserver` (testy w Node) zostaje wartość zapasowa z CSS (jedna linijka). */
export function trackPlSlot(box: HTMLElement, pl: HTMLElement): void {
  if (typeof ResizeObserver === 'undefined') return;
  new ResizeObserver(() => {
    const height = pl.getBoundingClientRect().height;
    if (height > 0) box.style.setProperty('--pl-h', `${Math.round(height * 100) / 100}px`);
  }).observe(pl);
}
